/**
 * wrapper for react-datez component
 */

// deps
// import Input from 'react-validation/build/input';
import { ReactDatez } from 'react-datez';
import PropTypes from 'prop-types';
const internals = {};

internals.padNum = (n) => n < 10 ? '0' + n : n;

internals.dateFormatOptions = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
};

export default class CustomDatepicker extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        wrapperClassName: PropTypes.string,
        validations: PropTypes.array,
        inputClassName: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string,
        isRequired: PropTypes.bool,
        displayStringDate: PropTypes.bool,
        displayPlaceHolder: PropTypes.bool,
        updateExternalState: PropTypes.func,
        allowPast: PropTypes.bool,
        allowFuture: PropTypes.bool,
        calendarClassName: PropTypes.string
    };

    static defaultProps = {
        name: '',
        wrapperClassName: '',
        validations: [],
        inputClassName: '',
        startDate: '',
        endDate: '',
        isRequired: false,
        displayStringDate: true,
        displayPlaceHolder: false,
        updateExternalState: () => {},
        allowPast: false,
        allowFuture: true,
        calendarClassName: ''
    };

    constructor() {
        super();

        this.state = {
            selectedDateValue: '',
            selectedDateString: '',
            selectedDateValueMDY: ''
        };
    }

    onDatepickerChange = (date) => {

        const selectedDate = new Date(date);
        const selectedDateDay = selectedDate.getDate();
        const selectedDateMonth = selectedDate.getMonth() + 1;
        const selectedDateString = selectedDate.toLocaleDateString('en-US', internals.dateFormatOptions);
        const selectedDateValue = `${internals.padNum(selectedDateMonth)}/${internals.padNum(selectedDateDay)}/${selectedDate.getFullYear()}`;
        
        this.setState({ selectedDateValue, selectedDateString }, () => {
            const onChangeEvent = document.createEvent('HTMLEvents');

            onChangeEvent.initEvent('change', true, true);
            const target = $(`input[name=${this.props.name}]`).get(0);

            target.dispatchEvent(onChangeEvent);
            this.props.updateExternalState(selectedDateValue);
        });
        
        let selectedDateValueMDYArray = (selectedDateValue).split('\/');
        this.setState({ selectedDateValueMDY: ([ selectedDateValueMDYArray[1], selectedDateValueMDYArray[0], selectedDateValueMDYArray[2] ].join('/')) });
    }

    render() {
        const startDate = this.props.startDate === '' ? '' : new Date(this.props.startDate).toISOString();

        return(
            <div className={`control-wrapper ${this.props.wrapperClassName}`}>
                <div className="datepicker-text">
                    {
                        (this.props.displayStringDate) ? this.state.selectedDateString : this.state.selectedDateValueMDY
                    }
                    {
                        (this.props.displayPlaceHolder && (this.state.selectedDateString.length === 0 && this.state.selectedDateValue.length === 0)) ? (<span>dd/mm/yyyy</span>) : ''
                    }
                </div>
                <ReactDatez
                    dateFormat="DD/MM/YYYY"
                    handleChange={ this.onDatepickerChange }
                    className={`react-datez-control ${this.props.calendarClassName}`}
                    disableInputIcon
                    allowPast= { this.props.allowPast }
                    allowFuture= { this.props.allowFuture }
                    startDate={ startDate }
                    endDate={ this.props.endDate }
                    defaultMonth={ startDate }
                />
                <input
                    type="text"
                    name={ this.props.name }
                    className={`hidden-input hide ${this.props.inputClassName}`}
                    value={this.state.selectedDateValue}
                    required={ this.props.isRequired }
                />
            </div>
        );
    }
}
